import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { Country, State, City } from "country-state-city";
import { LoadScript, Autocomplete } from "@react-google-maps/api";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateClient,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [hubs, setHubs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [autocomplete, setAutocomplete] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [selectedStateCode, setSelectedStateCode] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (select_data) {
      setSelectedCountryCode(select_data.country || "");
      setSelectedStateCode(select_data.state || "");
      setUpdate_modal_data({
        ...select_data,
        id_hub: select_data.id_hub?._id || select_data.id_hub || "",
        buyerName: select_data.buyerName || "",
        otRate: select_data.otRate ?? 0,
        extrakmRate: select_data.extrakmRate ?? 0,
        hasGST: Boolean(select_data.hasGST),
        gstDetails: {
          gstNumber: select_data.gstDetails?.gstNumber || "",
          gstPercentage: select_data.gstDetails?.gstPercentage ?? "",
          tdsPercentage: select_data.gstDetails?.tdsPercentage ?? "",
        },
      });
    }
  }, [select_data, hubs]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "latitude" || name === "longitude") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        coordinates: { ...prevData.coordinates, [name]: value },
      }));
    } else if (name === "id_hub") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        id_hub: { ...prevData.id_hub, [name]: value },
      }));
    } else if (name === "clientImage") {
      setUpdate_modal_data({ ...update_modal_data, [name]: files });
    } else if (name === "check_in" || name === "check_out") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        shift_hours: {
          ...prevData.shift_hours,
          [name]: value,
        },
      }));
    } else if (["gstNumber", "gstPercentage", "tdsPercentage"].includes(name)) {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        gstDetails: {
          ...(prevData.gstDetails || {}),
          [name]: value,
        },
      }));
    } else if (name === "hasGST") {
      const checked = e.target.checked;
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        hasGST: checked,
        gstDetails: checked
          ? prevData.gstDetails || {
              gstNumber: "",
              gstPercentage: "",
              tdsPercentage: "",
            }
          : { gstNumber: "", gstPercentage: "", tdsPercentage: "" },
      }));
    } else {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    }
  };

  const validateFields = () => {
    const newErrors = {};
    if (!update_modal_data.name) newErrors.name = "Client name is required";
    if (!update_modal_data.payout) newErrors.payout = "Payout is required";

    if (!update_modal_data.payoutperpacket)
      newErrors.payoutperpacket = "Payout per packet is required";
    if (!update_modal_data.id_hub)
      newErrors.id_hub = "Hub assignment is required";
    if (!update_modal_data.status) newErrors.status = "Status is required";
    if (!update_modal_data.clientImage)
      newErrors.clientImage = "Client Image is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { _id } = update_modal_data;
          if (!_id) {
            throw new Error("ID is not defined");
          }

          // Create a new FormData object
          const formData = new FormData();
          // Append coordinates correctly
          if (update_modal_data.coordinates) {
            formData.append(
              "coordinates[longitude]",
              update_modal_data.coordinates.longitude || "",
            );
            formData.append(
              "coordinates[latitude]",
              update_modal_data.coordinates.latitude || "",
            );
          }

          if (update_modal_data.shift_hours) {
            const { shift_hours } = update_modal_data;
            if (shift_hours.check_in) {
              formData.append("shift_hours[check_in]", shift_hours.check_in);
            }
            if (shift_hours.check_out) {
              formData.append("shift_hours[check_out]", shift_hours.check_out);
            }
          }

          formData.append("name", update_modal_data.name);
          formData.append("contactname", update_modal_data.contactname);
          formData.append("phonenumber", update_modal_data.phonenumber);
          formData.append("designation", update_modal_data.designation);
          formData.append("salary", update_modal_data.salary);
          formData.append("payout", update_modal_data.payout);
          formData.append("buyerName", update_modal_data.buyerName || "");
          formData.append("otRate", update_modal_data.otRate ?? 0);
          formData.append("extrakmRate", update_modal_data.extrakmRate ?? 0);
          formData.append("adhocAmount", update_modal_data.adhocAmount);
          formData.append("payoutperpacket", update_modal_data.payoutperpacket);
          formData.append("id_hub", update_modal_data.id_hub);
          formData.append("status", update_modal_data.status);
          formData.append("onBoardingDate", update_modal_data.onBoardingDate);
          formData.append("shift", update_modal_data.shift || "");
          formData.append("hasGST", String(Boolean(update_modal_data.hasGST)));
          if (update_modal_data.hasGST) {
            formData.append(
              "gstDetails",
              JSON.stringify({
                gstNumber: (update_modal_data.gstDetails?.gstNumber || "")
                  .trim()
                  .toUpperCase(),
                gstPercentage: Number(
                  update_modal_data.gstDetails?.gstPercentage || 0,
                ),
                tdsPercentage: Number(
                  update_modal_data.gstDetails?.tdsPercentage || 0,
                ),
              }),
            );
          } else {
            formData.append(
              "gstDetails",
              JSON.stringify({
                gstNumber: "",
                gstPercentage: 0,
                tdsPercentage: 0,
              }),
            );
          }

          // Append the file if it exists
          if (
            update_modal_data.clientImage &&
            update_modal_data.clientImage[0]
          ) {
            formData.append("clientImage", update_modal_data.clientImage[0]);
          }

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v1/client/${_id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
              },
            },
          );

          if (res.data.success) {
            Swal.fire("Update success", "", "success");
            onUpdateClient(update_modal_data);
            setRen(!ren);
          }
        } catch (error) {
          Swal.fire("Update failed", "", "error");
        }
        set_update_data_modal_Show(false);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setUpdate_modal_data((prevData) => ({
          ...prevData,
          coordinates: { latitude: lat, longitude: lng },
        }));
      }
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };

  useEffect(() => {
    const fetchHubs = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setHubs(response.data.hubs);
      } catch (error) {
        setHubs([]);
      }
    };
    fetchHubs(currentPage);
  }, [currentPage]);

  const handleHubChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      id_hub: value,
    }));
  };

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Client Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Client Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={update_modal_data.name || ""}
                onChange={handleChange}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Shift-in Time *</Form.Label>
              <Form.Control
                type="time"
                name="check_in"
                value={update_modal_data.shift_hours?.check_in}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Shift-out Time *</Form.Label>
              <Form.Control
                type="time"
                name="check_out"
                value={update_modal_data.shift_hours?.check_out}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Client Salary (Per Trip) </Form.Label>
              <Form.Control
                type="number"
                name="salary"
                value={update_modal_data.salary || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Payouts *</Form.Label>
              <Form.Control
                type="number"
                name="payout"
                value={update_modal_data.payout || ""}
                onChange={handleChange}
                isInvalid={!!errors.payout}
              />
              <Form.Control.Feedback type="invalid">
                {errors.payout}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Payout Per Packet *</Form.Label>
              <Form.Control
                type="number"
                name="payoutperpacket"
                value={update_modal_data.payoutperpacket || ""}
                onChange={handleChange}
                isInvalid={!!errors.payoutperpacket}
              />
              <Form.Control.Feedback type="invalid">
                {errors.payoutperpacket}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Buyer Name */}
            <Form.Group className="mb-3">
              <Form.Label>Buyer Name</Form.Label>
              <Form.Control
                type="text"
                name="buyerName"
                placeholder="Enter Buyer Name"
                value={update_modal_data.buyerName || ""}
                onChange={handleChange}
              />
            </Form.Group>

            {/* OT Rate */}
            <Form.Group className="mb-3">
              <Form.Label>OT Rate(Per Hour)</Form.Label>
              <Form.Control
                type="number"
                name="otRate"
                min="0"
                step="0.01"
                placeholder="Enter OT Rate"
                value={update_modal_data.otRate ?? 0}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Extra KM Rate */}
            <Form.Group className="mb-3">
              <Form.Label>Extra KM Rate(Per KM)</Form.Label>
              <Form.Control
                type="number"
                name="extrakmRate"
                min="0"
                step="0.01"
                placeholder="Enter Extra KM Rate"
                value={update_modal_data.extrakmRate ?? 0}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Assign Hub *</Form.Label>
              <Form.Control
                as="select"
                name="id_hub"
                value={update_modal_data.id_hub || ""}
                onChange={handleHubChange}
                isInvalid={!!errors.id_hub}
              >
                <option value="">Select Hub</option>
                {hubs.map((hub) => (
                  <option key={hub._id} value={hub._id}>
                    {hub.name}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.id_hub}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Status *</Form.Label>
              <Form.Control
                as="select"
                name="status"
                value={update_modal_data.status || ""}
                onChange={handleChange}
                isInvalid={!!errors.status}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.status}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>OnBoard Date *</Form.Label>
              <Form.Control
                type="date"
                name="onBoardingDate"
                value={update_modal_data.onBoardingDate || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Location *</Form.Label>
              <LoadScript
                googleMapsApiKey={process.env.REACT_APP_BASE_API}
                libraries={["places"]}
              >
                <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                  <input
                    type="text"
                    placeholder="Search places..."
                    className="form-control"
                  />
                </Autocomplete>
              </LoadScript>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Longitude</Form.Label>
              <Form.Control
                type="text"
                name="longitude"
                value={update_modal_data.coordinates?.longitude || ""}
                onChange={handleChange}
              />
              {errors.coordinates && (
                <small className="text-danger">{errors.coordinates}</small>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Latitude</Form.Label>
              <Form.Control
                type="text"
                name="latitude"
                value={update_modal_data.coordinates?.latitude || ""}
                onChange={handleChange}
              />
              {errors.coordinates && (
                <small className="text-danger">{errors.coordinates}</small>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Shift</Form.Label>
              <Form.Control
                as="select"
                name="shift"
                value={update_modal_data.shift || ""}
                onChange={handleChange}
                isInvalid={!!errors.shift}
              >
                <option value="">Select Shift</option>
                <option value="Morning">Morning</option>
                <option value="Evening">Evening</option>
                <option value="FullDay">Full-Day</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.shift}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                id="hasGST"
                name="hasGST"
                label="GST Applicable"
                checked={Boolean(update_modal_data.hasGST)}
                onChange={handleChange}
              />
            </Form.Group>

            {update_modal_data.hasGST && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label>GST Number *</Form.Label>
                  <Form.Control
                    type="text"
                    name="gstNumber"
                    value={update_modal_data.gstDetails?.gstNumber || ""}
                    onChange={handleChange}
                    required
                    placeholder="Enter GST number"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>GST Percentage (%) *</Form.Label>
                  <Form.Control
                    type="number"
                    name="gstPercentage"
                    min="0"
                    max="100"
                    value={update_modal_data.gstDetails?.gstPercentage ?? ""}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>TDS Percentage (%) *</Form.Label>
                  <Form.Control
                    type="number"
                    name="tdsPercentage"
                    min="0"
                    max="100"
                    value={update_modal_data.gstDetails?.tdsPercentage ?? ""}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </>
            )}

            <Form.Group className="mb-3">
              <Form.Label>Adhoc Amount </Form.Label>
              <Form.Control
                type="number"
                name="adhocAmount"
                value={update_modal_data.adhocAmount || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Contact Name</Form.Label>
              <Form.Control
                type="text"
                name="contactname"
                value={update_modal_data.contactname || ""}
                onChange={handleChange}
                isInvalid={!!errors.contactname}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phonenumber </Form.Label>
              <Form.Control
                type="number"
                name="phonenumber"
                value={update_modal_data.phonenumber || ""}
                onChange={handleChange}
                isInvalid={!!errors.phonenumber}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Designation</Form.Label>
              <Form.Control
                type="text"
                name="designation"
                value={update_modal_data.designation || ""}
                onChange={handleChange}
                isInvalid={!!errors.designation}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Client Image *</Form.Label>
              <Form.Control
                type="file"
                name="clientImage"
                accept="image/*"
                onChange={handleChange}
              />
              {errors.clientImage && (
                <small className="text-danger">{errors.clientImage}</small>
              )}
            </Form.Group>

            {/* Image Preview */}
            {(update_modal_data.clientImage &&
              update_modal_data.clientImage[0]) ||
            select_data.clientImage?.url ? (
              <Form.Group className="mb-3">
                <Form.Label>Image Preview</Form.Label>
                <div className="d-flex justify-content-center">
                  <img
                    src={
                      update_modal_data.clientImage &&
                      update_modal_data.clientImage[0] instanceof File
                        ? URL.createObjectURL(update_modal_data.clientImage[0])
                        : select_data.clientImage?.url
                    }
                    alt="Client Image"
                    style={{ maxWidth: "50%", height: "30%" }}
                    onLoad={() => {
                      if (
                        update_modal_data.clientImage &&
                        update_modal_data.clientImage[0] instanceof File
                      ) {
                        URL.revokeObjectURL(
                          URL.createObjectURL(update_modal_data.clientImage[0]),
                        );
                      }
                    }}
                  />
                </div>
              </Form.Group>
            ) : null}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Client
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
